export const translations = {
  selecione: {
    pt: 'Selecione...',
    en: 'Select...',
    de: 'wählen Sie...',
    es: 'Seleccione...',
  },
};